export default {
  install(Vue, options = {}) {
    const loaderMethods = {
      show() {
        options.store.commit("isLoading/incrementLoading");
      },
      hide() {
        options.store.commit("isLoading/decrementLoading");
      },
      setType(type) {
        options.store.commit("isLoading/setLoaderType", type);
      },
      setAppLoading(value) {
        options.store.commit("isLoading/setAppLoading", value);
      },
    };

    const reactiveData = new Vue({
      computed: {
        isAppLoading() {
          return options.store.state.isLoading.appLoading;
        },
        isLoading() {
          return options.store.state.isLoading.isLoading;
        },
      },
    });

    Object.defineProperty(Vue.prototype, "$loader", {
      get() {
        return {
          ...loaderMethods,
          get isAppLoading() {
            return reactiveData.isAppLoading;
          },
          get isLoading() {
            return reactiveData.isLoading;
          },
        };
      },
    });
  },
};
